/**
 *
 * Component: Avatar
 * Date: 22/1/2021
 *
 */

import React from 'react';
import { Avatar as CustomAvatar } from 'antd';
import styles from './style.module.css';

const Avatar = ({ ...rest }) => {
  return (
    <div className={styles.container}>
      <CustomAvatar {...rest} />
    </div>
  );
};

export default Avatar;
